import { Button, Result, Space } from 'antd';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import styles from './SubscriptionSuccessPage.module.scss';

const SubscriptionSuccessPage: React.FC = () => {
    return (
        <>
            <Result
                status={'success'}
                title={<FormattedMessage id="subscriptionSuccess.title" tagName="h1" />}
                subTitle={<FormattedMessage id="subscriptionSuccess.description" tagName="p" />}
                extra={
                    <Space>
                        <Link to="/">
                            <Button type="primary" size="large" className={styles.next}>
                                <FormattedMessage id="subscriptionSuccess.next" tagName="span" />
                            </Button>
                        </Link>
                    </Space>
                }
                className={styles.result}
            />
        </>
    );
};
export default SubscriptionSuccessPage;
